module.exports = __webpack_public_path__ + "img/svg/divider-long.6b917f58f6f9ec4a70d45ec566d08a76.svg";